import Header from "../../components/Header";
import Footer from "../../components/Footer";

import './styles.css';

import LIBRARY from '../../images/library.png';
import BASKETBALL from '../../images/basketball.png';
import CAFETERIA from '../../images/cafeteria.png';

function Course() {
  return (
    <div className="">
        <Header 
        title={'Our Courses'}/>
        {/* Course */}
        <section class="course">
            <h1>Courses We Offer</h1>
            <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit.</p>

            <div class="row">
                <div class="course-col">
                    <h3>Intermediate</h3>
                    <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Pellentesque aliquet turpis mulla, elefend faucubus est sollicitudin ut. Maecenas ut venenat is ex, et dapibus purnus Donec sit.</p>
                </div>
                <div class="course-col">
                    <h3>Degreen</h3>
                    <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Pellentesque aliquet turpis mulla, elefend faucubus est sollicitudin ut. Maecenas ut venenat is ex, et dapibus purnus Donec sit.</p>
                </div>
                <div class="course-col">
                    <h3>Post Graduation</h3>
                    <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Pellentesque aliquet turpis mulla, elefend faucubus est sollicitudin ut. Maecenas ut venenat is ex, et dapibus purnus Donec sit.</p>
                </div>
            </div>
        </section>

        {/* Facilities */}
        <section class="facilities">
            <h1>Our Facilities</h1>
            <p>Our university boasts a wide range of facilities designed to enhance the learning, and experience of our students and faculty members.</p>

            <div class="row">
                <div class="facilities-col">
                    <img src={'https://media.istockphoto.com/id/1449285433/photo/school-library.webp?s=170667a&w=0&k=20&c=NNZn7e29MxBOsJZOdRrVGh27rZCHIJsAvBLKE7KeLuI='} alt='' />
                    <h3>World Class Library</h3>
                    <p>library of our university, where knowledge knows no bounds and information is at your fingertips. Our library stands as a beacon of academic excellence, offering a rich collection of resources and a serene environment for intellectual exploration.</p>
                </div>
                <div class="facilities-col">
                    <img src={'https://images.unsplash.com/photo-1547347298-4074fc3086f0?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1yZWxhdGVkfDJ8fHxlbnwwfHx8fHw%3D&auto=format&fit=crop&w=500&q=60'} alt='' />
                    <h3>Largest Play Ground</h3>
                    <p>The university play grounds are sprawling outdoor spaces designed to promote physical activity, sportsmanship, and recreational opportunities for students, faculty, and staff. These play grounds are meticulously maintained and offer a range of facilities and amenities.</p>
                </div>
                <div class="facilities-col">
                    <img src={'https://media.istockphoto.com/id/682880248/photo/a-nice-time-to-enjoy-coffee-and-cake.webp?s=170667a&w=0&k=20&c=Px3rRo6au2NjG5ohBLBu_K7mzcjkm6HscUH8BqOr4gQ='} alt='' />
                    <h3>Tasty and Healthy Food</h3>
                    <p>At our university, we understand the importance of providing tasty and healthy food options to support the overall well-being of our students and faculty members.</p>
                </div>
            </div>
        </section>

        <Footer/>
    </div>
  );
}

export default Course;
